// frontend/klaes-app/src/components/FilmFavs/components/EntryModal.jsx
import { useState } from 'react';
import { BatteryIndicator } from './BatteryIndicator';
import { Chip } from './Chip';
import { TagPicker } from './TagPicker';
import styles from '../FilmFavs.module.css';

export const EntryModal = ({ onSave, onClose, initialData, existingNames, allTags, currentUser, onCreateTag }) => {
  const [formData, setFormData] = useState(initialData || {
    name: '',
    description: '',
    type: 'film',
    tags: [],
    rating: 50
  });
  const [error, setError] = useState('');
  const [showTagPicker, setShowTagPicker] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setError('Bitte einen Namen eingeben');
      return;
    }
    if (!initialData && existingNames.includes(formData.name.toLowerCase())) {
      setError('Ein Eintrag mit diesem Namen existiert bereits!');
      return;
    }
    // Stelle sicher, dass rating immer ein Number ist
    const rating = formData.rating !== undefined ? formData.rating : 50;
    onSave(formData, rating);
  };

  const addTag = (tag) => {
    if (!formData.tags.find(t => t.name === tag.name)) {
      setFormData({ ...formData, tags: [...formData.tags, tag] });
    }
  };

  const removeTag = (tagToRemove) => {
    setFormData({
      ...formData,
      tags: formData.tags.filter(t => t !== tagToRemove)
    });
  };

  return (
    <>
      <div className={styles.modalOverlay} onClick={onClose}>
        <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
          <h3>{initialData ? 'Eintrag bearbeiten' : 'Neuen Eintrag hinzufügen'}</h3>
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label>Typ</label>
              <select 
                value={formData.type} 
                onChange={(e) => setFormData({...formData, type: e.target.value})}
                className={styles.select}
              >
                <option value="film">Film</option>
                <option value="series">Serie</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label>Name *</label>
              <input 
                type="text" 
                value={formData.name} 
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                className={styles.input}
              />
            </div>

            <div className={styles.formGroup}>
              <label>Beschreibung</label>
              <textarea 
                value={formData.description} 
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                rows={3}
                className={styles.textarea}
              />
            </div>

            <div className={styles.formGroup}>
              <label>Tags/Chips</label>
              <div className={styles.tagPickerButton}>
                <button type="button" onClick={() => setShowTagPicker(true)} className={styles.openTagPickerBtn}>
                  🏷️ Tags auswählen ({formData.tags.length})
                </button>
              </div>
              <div className={styles.selectedTags}>
                {formData.tags.map((tag, i) => (
                  <Chip 
                    key={i} 
                    label={tag.name} 
                    category={tag.category}
                    onRemove={() => removeTag(tag)}
                  />
                ))}
              </div>
            </div>

            <div className={styles.formGroup}>
              <label>Deine Bewertung</label>
              <div className={styles.ratingContainerInline}>
                <input 
                  type="range" 
                  min="0" 
                  max="100" 
                  step="0.1" 
                  value={formData.rating !== undefined ? formData.rating : 50}
                  onChange={(e) => setFormData({...formData, rating: parseFloat(e.target.value)})}
                  className={styles.ratingSlider}
                />
                <BatteryIndicator 
                  rating={formData.rating !== undefined ? formData.rating : 50} 
                  isUserRating 
                />
              </div>
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <div className={styles.modalButtons}>
              <button type="submit" className={styles.saveBtn}>
                {initialData ? 'Speichern' : 'Erstellen'}
              </button>
              <button type="button" onClick={onClose} className={styles.cancelBtn}>Abbrechen</button>
            </div>
          </form>
        </div>
      </div>

      {showTagPicker && (
        <TagPicker 
          onSelectTag={addTag}
          onClose={() => setShowTagPicker(false)}
          existingTags={allTags}
          onCreateTag={onCreateTag}
          selectedTags={formData.tags}
        />
      )}
    </>
  );
};